export default __webpack_public_path__ + "static/media/CarImages.PicantoGallery2.2a83af87.jpg";